import { useMutation } from "@apollo/react-hooks";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import styled, { createGlobalStyle } from "styled-components";
import { DETACH_CONTACT_TAG } from "../../graphql/queries";
import colors from "../../styles/colors";
import { SEARCH_TYPES } from "../../util/customersUtil";
import BaseModal, { ModalList } from "../modals/BaseModal";

const CustomStyles = createGlobalStyle`
.__react_component_tooltip{
      display: inline-block !important;
      max-width: 300px;
    };
    .css-12jo7m5{
      font-size:13px !important;
    };

    .css-1rhbuit-multiValue{
      background: rgba(26,188,156,0.1) !important;
      &>div{
        color: ${colors.seaGreen};
      };
    };
`;

const TagsContainer = styled.div`
  font-size: 1.3rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const TagsListContainer = styled.div`
  font-size: 1.3rem;
  width: 78%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  max-width: 200px;
`;

const ToolbarItem = styled.div`
  word-wrap: break-word;
  word-break: break-all;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
  font-weight: ${(props) => (props.active ? "600" : "500")};
  color: ${(props) => (props.active ? colors.seaGreen : colors.grey3)};
  margin: 5px 2px 5px 0;
  font-size: 1.2rem;
  width: ${(props) => props.width || "max-content"};
  cursor: ${(props) => (props.onClick ? "pointer" : null)};
  border-radius: 10px;
  padding: ${(props) => props.padding || "2px 5px 2px 8px"};
  background: ${(props) => (props.active ? "rgba(26, 188, 156, 0.1)" : null)};
  height: ${(props) => props.height || null};
`;

const CrossButton = styled.div`
  margin-left: 5px;
  padding: 3px 7px;
  border-radius: 50%;
  cursor: pointer;
  &:hover {
    color: red;
    background-color: rgb(189, 195, 199);
  }
`;

const TagsList = ({
  phoneNumber,
  attachedTags,
  searchQuery,
  setSearchQuery,
}) => {
  const [deleteConfirmVisible, setDeleteConfirmVisible] = useState(false);
  const [tagToDelete, setTagToDelete] = useState({});
  const [linkTagsModal, setLinkTagsModal] = useState(false);
  const [selectedTags, setSelectedTags] = useState(attachedTags);


  const [detachContactTags, { loading: detachTagLoading }] = useMutation(
    DETACH_CONTACT_TAG,
    {
      onCompleted() {
        toast.success("Successfully Removed");
        const updatedTags = selectedTags.filter((tag) => tag !== tagToDelete);
        setSelectedTags(updatedTags);
        setDeleteConfirmVisible(false);
        if (searchQuery.type === SEARCH_TYPES.TagsFiltered) {
          setSearchQuery((old) => ({ ...old, refreshList: !old.refreshList }));
        }
      },
    }
  );

  const detachTagsFromContact = (phone, tags) => {
    detachContactTags({
      variables: {
        phoneNumber: phone,
        tags,
      },
    });
  };

  useEffect(() => {
    setSelectedTags(attachedTags)
  }, [attachedTags])
  

  return (
    <>
      <CustomStyles />
      <BaseModal
        open={deleteConfirmVisible}
        modalType={ModalList.DetachContactTag}
        onClose={setDeleteConfirmVisible}
        loading={detachTagLoading}
        onConfirm={() => detachTagsFromContact(phoneNumber, [tagToDelete])}
        header="Are you sure you want to remove this tag from this contact?"
      />
      <BaseModal
        open={linkTagsModal}
        modalType={ModalList.AttachContactTags}
        onClose={setLinkTagsModal}
        attachedTags={selectedTags}
        setAttachedTags={setSelectedTags}
        phoneNumber={phoneNumber}
      />

      <TagsContainer>
        <TagsListContainer>
          {selectedTags.map((item, index) => {
            return (
              <ToolbarItem active={true} key={index} headerDirection="column">
                {item}
                <CrossButton
                  onClick={() => {
                    setDeleteConfirmVisible(true);
                    setTagToDelete(item);
                  }}
                >
                  x
                </CrossButton>
              </ToolbarItem>
            );
          })}
        </TagsListContainer>
        <ToolbarItem
          height="35px"
          padding="2px 10px"
          width={!selectedTags.length ? "inherit" : "20%"}
          active={true}
          headerDirection="column"
          onClick={() => {
            setLinkTagsModal(true);
          }}
        >
          +
        </ToolbarItem>
      </TagsContainer>
    </>
  );
};

export default TagsList;
